/* eslint-disable import/prefer-default-export */

export const DST_ATTEMPT_MAP = {
  UNATTEMPTED: 0,
  RESUME_NOW: 1,
  VIEW_SUMMARY: 2,
  REATTEMPT: 3,
  WON: 4
};

export const DST_MAX_QUIZ_ATTEMPTED = 0;

export const DST_MAX_ATTEMPT_TIMES = 3;

export const DEFAULT_INSTRUCTIONS =
  '<ul><li>The test contains 15 questions which have to be attempted within duration of 15 minutes or less.</li><li>The test would contain multiple-choice questions with 4 options. Questions can have single option or multi option solutions.</li><li>All questions carry 4 marks and incorrect responses carry negative 1 mark for each question.</li><li>No marks would be awarded or deducted for unattempted questions.</li></ul>';

// LPS
export const TEST_DETAILS_PAGE = 'Test Details Page';
export const TEST_ATTEMPTS_PAGE = 'Test Attempts Page';

export const DST_INFO = {
  TOTAL_QUESTIONS: 15,
  TOTAL_SCORE: 60,
  DURATION: 900
};
